/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckResetPasswordTokenCommand
 */
export interface CheckResetPasswordTokenCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckResetPasswordTokenCommand
     */
    token: string;
}

export function CheckResetPasswordTokenCommandFromJSON(json: any): CheckResetPasswordTokenCommand {
    return CheckResetPasswordTokenCommandFromJSONTyped(json, false);
}

export function CheckResetPasswordTokenCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckResetPasswordTokenCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function CheckResetPasswordTokenCommandToJSON(value?: CheckResetPasswordTokenCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

